import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { SsoModalProps } from '../login.types'
import Button from '../../../atoms/fields/Button/Button'
import { BUTTON_COLOR } from '../../../atoms/fields/Button/button.enum'

type SsoLoginProps = Partial<SsoModalProps>

export const SsoLogin: FC<SsoLoginProps> = ({
  onLoginGoogle,
  isLoadingLoginGoogle,
  onLoginAzure,
  isLoadingLoginAzure,
}) => {
  if (!onLoginGoogle || !onLoginAzure) {
    return null
  }

  return (
    <>
      <div className={s.ssoSpacer}>
        <div className={s.ssoBar} />
        <span>
          <FormattedMessage id='ui.SsoLogin.or' defaultMessage='OU' />
        </span>
        <div className={s.ssoBar} />
      </div>
      <div className={s.ssoContainer}>
        <Button
          className={s.ssoBtn}
          onClick={onLoginGoogle}
          loading={isLoadingLoginGoogle}
          fullWidth={true}
          color={BUTTON_COLOR.SECONDARY}
        >
          <div className={s.ssoBtnContent}>
            <img src='/google-logo.png' alt='google-logo' />
            <span>
              <FormattedMessage
                id='ui.SsoLogin.continueWithGoogle'
                defaultMessage='Continuer avec Google'
              />
            </span>
          </div>
        </Button>
        <Button
          className={s.ssoBtn}
          onClick={onLoginAzure}
          loading={isLoadingLoginAzure}
          fullWidth={true}
          color={BUTTON_COLOR.SECONDARY}
        >
          <div className={s.ssoBtnContent}>
            <img src='/microsoft-logo.png' alt='microsoft-logo' />
            <span>
              <FormattedMessage
                id='ui.SsoLogin.continueWithMicrosoft'
                defaultMessage='Continuer avec Microsoft'
              />
            </span>
          </div>
        </Button>
      </div>
    </>
  )
}
